module.exports = __webpack_public_path__ + "static/content-magento-4868561304fbfab5e1d001756b39e55f.jpg";